import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
export const Message = (props) => {
    const { children, title, type, variant = 'standard' } = props;
    return (React.createElement(Alert, { severity: type, variant: variant },
        title && React.createElement(AlertTitle, null, title),
        children));
};
